import { ICarrierAccountingRequest } from 'types/carrier'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const CARRIER_ACCOUNTING_MODAL = keymirror({
  CARRIER_ACCOUNTING_MODAL_OPEN: undefined,
  CARRIER_ACCOUNTING_MODAL_CLOSE: undefined,
})

export const openCarrierAccountingModal = () => ({
  type: CARRIER_ACCOUNTING_MODAL.CARRIER_ACCOUNTING_MODAL_OPEN,
})

export const closeCarrierAccountingModal = () => ({
  type: CARRIER_ACCOUNTING_MODAL.CARRIER_ACCOUNTING_MODAL_CLOSE,
})

export const CARRIER_ACCOUNTING_ACTION_TYPES = generateApiActionTypes('CARRIER_ACCOUNTING')
export const fetchCarrierAccounting = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'GET',
    group: 'accounting',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CARRIER_ACCOUNTING_ACTION_TYPES),
    },
  }
}

export const CARRIER_EDIT_ACCOUNTING_ACTION_TYPES = generateApiActionTypes(
  'CARRIER_EDIT_ACCOUNTING'
)
export const updateCarrierAccounting = (id: string, payload: ICarrierAccountingRequest) => {
  const finalPayload = {
    factorId: payload.factorId,
    carrierBillingLocation: {
      address: payload.carrierBillingLocation.address,
      address_line_2: payload.carrierBillingLocation.addressLine2,
      city: payload.carrierBillingLocation.city,
      stateCode: payload.carrierBillingLocation.stateCode,
      countryCode: payload.carrierBillingLocation.countryCode,
      zipcode: payload.carrierBillingLocation.zipcode,
      contactEmail: payload.carrierBillingLocation.contactEmail,
      contactPhone: payload.carrierBillingLocation.contactPhone,
    },
  }
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    method: 'PUT',
    group: 'accounting',
    body: finalPayload,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CARRIER_EDIT_ACCOUNTING_ACTION_TYPES),
    },
  }
}
